import { render } from "./InfoText.vue?vue&type=template&id=27235892"
import script from "./InfoText.vue?vue&type=script&lang=js"
export * from "./InfoText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/InfoText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27235892"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27235892', __exports__)) {
    api.reload('27235892', __exports__)
  }
  
  module.hot.accept("./InfoText.vue?vue&type=template&id=27235892", () => {
    api.rerender('27235892', render)
  })

}


export default __exports__